export default "__VITE_ASSET__BqO9gSe3__"